"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
// eslint-disable-next-line no-unused-expressions
(0, css_1.injectGlobal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @import url('//fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700');\n"], ["\n  @import url('//fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700');\n"])));
var Text = function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? 'primary' : _b, italic = _a.italic, _c = _a.size, size = _c === void 0 ? 14 : _c, _d = _a.weight, weight = _d === void 0 ? 'regular' : _d, restProps = __rest(_a, ["className", "color", "italic", "size", "weight"]);
    return (react_1["default"].createElement("span", __assign({}, restProps, { className: (0, css_1.cx)((0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        font-family: 'Roboto', -system-ui, -apple-system, BlinkMacSystemFont,\n          'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji',\n          'Segoe UI Emoji', 'Segoe UI Symbol';\n        line-height: 1.6;\n        -moz-osx-font-smoothing: grayscale;\n        -webkit-font-smoothing: antialiased;\n        ", "\n        font-size: var(", ");\n        font-weight: var(", ");\n        ", "\n      "], ["\n        font-family: 'Roboto', -system-ui, -apple-system, BlinkMacSystemFont,\n          'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji',\n          'Segoe UI Emoji', 'Segoe UI Symbol';\n        line-height: 1.6;\n        -moz-osx-font-smoothing: grayscale;\n        -webkit-font-smoothing: antialiased;\n        ", "\n        font-size: var(", ");\n        font-weight: var(", ");\n        ", "\n      "])), color === 'link'
            ? "color: var(--color-text-link-default);\n             &:hover {\n               color: var(--color-text-link-hover);\n               text-decoration: underline;\n               cursor: pointer;\n             }"
            : "color: var(".concat("--color-text-".concat(color), ");"), "--font-font-size-".concat(size), "--font-font-weight-".concat(weight), italic && 'font-style: italic;'), className) })));
};
exports.Text = Text;
var templateObject_1, templateObject_2;
